import dayjs from 'dayjs';
import CreateEvent from '../modules/create-event';

export default calendar => {
  let _this = calendar;
  let el = document.querySelector(_this.el);
  let ch = [...el.querySelectorAll('[data-date]')];
  let isCheckin = el => el.classList.contains(_this.className.isCheckin);
  let isCheckout = el => el.classList.contains(_this.className.isCheckout);

  for (let i = 0; i < ch.length; i++) {
    let e = ch[i]
    e.addEventListener('click', () => {
      let d = new Date(e.getAttribute('data-year'), e.getAttribute('data-month'), e.getAttribute('data-date'));
      let state = _this.state;
      let pe = e.parentElement;

      switch (state) {
        case 'ready':
        case 'select_checkin':
          _this.checkin = d
          if (!dayjs(d).isBefore(_this.checkout, 'date')) {
            _this.checkout = dayjs(d).add(1, 'day').toDate()
          }
          _this.state = 'select_checkout_only'

          if ('select_checkout_only' === _this.state) {
            _this.render()
          } else {
            _this.renderRange()
          }
          break;
        case 'select_checkout':
        case 'select_checkout_only':
          if (isCheckin(pe)) return;
          _this.checkout = d
          _this.state = 'ready'
          _this.renderRange()
          break;
        default:;
      }

      CreateEvent('ready', {
        checkin: _this.checkin,
        checkout: _this.checkout
      }, el)
    });

    e.addEventListener('mouseenter', () => {
      let d = new Date(e.getAttribute('data-year'), e.getAttribute('data-month'), e.getAttribute('data-date'));
      let state = _this.state;
      let pe = e.parentElement;
      pe.classList.add(_this.className.isHover);

      switch (state) {
        case 'select_checkin':
          pe.classList.add(_this.className.isSelecting)
          break;
        case 'select_checkout':
        case 'select_checkout_only':
          if (!dayjs(d).isAfter(_this.checkin, 'date')) return;
          pe.classList.add(_this.className.isSelecting)

          if (dayjs(d).isAfter(_this.checkout, 'date')) {
            let hilightExtend = Array.prototype.filter.call(ch, node => {
              let e = new Date(node.getAttribute('data-date-format'));
              return dayjs(e).isAfter(_this.checkout, 'date') && !dayjs(e).isAfter(d, 'date');
            })
            let hilightExtendAfter = Array.prototype.filter.call(ch, node => {
              let e = new Date(node.getAttribute('data-date-format'));
              return dayjs(e).isAfter(d, 'date');
            })
            for (let i = 0; i < hilightExtend.length; i++) {
              let el = hilightExtend[i]
              el.parentElement.classList.add(_this.className.isSelected, 'is-range-extend')
            }
            for (let i = 0; i < hilightExtendAfter.length; i++) {
              let el = hilightExtendAfter[i]
              el.parentElement.classList.remove(_this.className.isSelected, 'is-range-extend')
            }
          } else {
            let hilightExtend = Array.prototype.filter.call(ch, node => {
              let e = new Date(node.getAttribute('data-date-format'));
              return dayjs(e).isAfter(_this.checkout, 'date')
            })
            for (let i = 0; i < hilightExtend.length; i++) {
              let el = hilightExtend[i]
              el.parentElement.classList.remove(_this.className.isSelected, 'is-range-extend')
            }
          }
          break;
        default:
      }
    });

    e.addEventListener('mouseleave', () => {
      let pe = e.parentElement;
      pe.classList.remove(_this.className.isHover, _this.className.isHold, 'is-selecting');
    });
  };
};
